import React from "react";
import { SuccessPaymentIcon } from "icons/payments/successPayment";
import { FailedAgreementIcon } from "icons/action/FailedIcon";
import { decode, encode } from "utils/HelperFunctions";
import { useNavigate } from "react-router-dom";
import { PaymentResultProps } from "types/subscriptionAndPlans";

const PaymentResultScreen: React.FC<PaymentResultProps> = ({
  screen,
  errrorMessage,
  id,
  setHandleDrawerSize,
  setIsPreview,
  setIsPreviewId,
  onClose,
  isPaymentPlan = false,
}) => {
  const navigate = useNavigate();

  if (screen) {
    return (
      <div className=" w-full lg:pt-[150px] pt-[100px] lg:px-0 px-5">
        <div className="w-full flex-col flex items-center justify-center gap-10 text-center">
          <SuccessPaymentIcon />
          <div>
            <p className="lg:text-2xl text-xl font-medium text-txtPrimary">
              {isPaymentPlan ? "Payment plan" : "Subscription"} updated
              successfully
            </p>
            <p className="lg:pt-6 pt-4 lg:text-base text-sm text-txtParagraph lg:leading-[20.83px] leading-[18.23px]">
              Your {isPaymentPlan ? "payment plan" : "subscription"} has been successfully updated.
            </p>
          </div>
          <div className="lg:text-base text-sm text-txtParagraph lg:leading-[20.83px] leading-[18.23px]">
            <span
              className="text-blue hover:!text-btnPrimaryHover underline cursor-pointer"
              onClick={() => {
                let paymentId = decode(id || "")?.split("_");
                setHandleDrawerSize?.(true);
                setIsPreview?.(true);
                setIsPreviewId?.(parseInt(paymentId[0]));
              }}
            >
              Click here
            </span>{" "}
            to view your full plan details.
            <div
              className="lg:text-base text-sm text-blue hover:!text-btnPrimaryHover cursor-pointer lg:pt-10 pt-5"
              onClick={() => {
                let clusterid = encode(decode(id)?.split("_")[1], "ci_");
                navigate(`/${clusterid}/dashboard`);
                onClose();
              }}
            >
              Back to dashboard
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className=" w-full lg:pt-[150px] pt-[100px] lg:px-[60px] px-5">
      <div className="w-full flex-col flex items-center justify-center gap-10 text-center">
        <FailedAgreementIcon />
        <div>
          <p className="lg:text-2xl text-xl font-medium text-txtPrimary">
            {errrorMessage || "Action failed"}
          </p>
          <p className="lg:pt-6 pt-4 lg:text-base text-sm text-txtParagraph lg:leading-[20.83px] leading-[18.23px] break-words">
            We encountered an issue while processing your request. Please try
            again later. If the problem persists, contact our support team for
            assistance.
          </p>
        </div>
        <div className="lg:text-base text-sm text-txtParagraph lg:leading-[20.83px] leading-[18.23px]">
          <div
            className="lg:text-base text-sm text-blue hover:!text-btnPrimaryHover cursor-pointer "
            onClick={() => {
              let clusterid = encode(decode(id)?.split("_")[1], "ci_");
              navigate(`/${clusterid}/dashboard`);
              onClose();
            }}
          >
            Back to dashboard
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentResultScreen;
